import Service from './service'
export var DispenserMessageType;
(function (DispenserMessageType) {
  DispenserMessageType["DISPENSER_FULL_STATUS"] = "DISPENSER_FULL_STATUS"
})(DispenserMessageType || (DispenserMessageType = {}))
export var ApiDispenserMessageType;
(function (ApiDispenserMessageType) {
  ApiDispenserMessageType["DISPENSER_DISPENSE"] = "dispenser.dispense"
  ApiDispenserMessageType["DISPENSER_FULL_STATUS"] = "dispenser.full_status"
})(ApiDispenserMessageType || (ApiDispenserMessageType = {}))
export var DispenserNotificationStatusType;
(function (DispenserNotificationStatusType) {
  /** Диспенсер готов к выдаче */
  DispenserNotificationStatusType["DISPENSER_IDLE"] = "dispenser.idle"
  /** Происходит процесс выдачи карты */
  DispenserNotificationStatusType["DISPENSER_CARD_DISPENSING"] = "dispenser.card.dispensing"
  /** Происходит процесс сброса карты */
  DispenserNotificationStatusType["DISPENSER_CARD_CAPTURING"] = "dispenser.card.capturing"
})(DispenserNotificationStatusType || (DispenserNotificationStatusType = {}))
export var DispenserWarningStatusType;
(function (DispenserWarningStatusType) {
  /** Корзина для сброса карт заполнена */
  DispenserWarningStatusType["DISPENSER_CARDBIN_FULL"] = "dispenser.cardbin.full"
  /** Карты почти закончились (можно продолжать работу) */
  DispenserWarningStatusType["DISPENSER_CARD_PREEMPTY"] = "dispenser.card.preempty"
  /** Карты закончились */
  DispenserWarningStatusType["DISPENSER_CARD_EMPTY"] = "dispenser.card.empty"
})(DispenserWarningStatusType || (DispenserWarningStatusType = {}))
export var DispenserErrorStatusType;
(function (DispenserErrorStatusType) {
  /** Ошибка выдачи карты */
  DispenserErrorStatusType["DISPENSER_CARD_DISPENSE_ERROR"] = "dispenser.card.dispense.error"
  /** Ошибка сброса карты */
  DispenserErrorStatusType["DISPENSER_CARD_CAPTURE_ERROR"] = "dispenser.card.capture.error"
  /** Отсутствует корзина для сброса карт */
  DispenserErrorStatusType["DISPENSER_NO_CAPTURE"] = "dispenser.card.nocapture"
})(DispenserErrorStatusType || (DispenserErrorStatusType = {}))
export var DispenserConnectionErrorStatusType;
(function (DispenserConnectionErrorStatusType) {
  /** Вышло время ожидания ответа от диспенсера */
  DispenserConnectionErrorStatusType["DISPENSER_COMMUNICATION_TIMEOUT"] = "dispenser.communication.timeout"
  /** Отсутствует подключение к диспенсеру */
  DispenserConnectionErrorStatusType["DISPENSER_NOT_CONNECTED"] = "dispenser.not.connected"
  /** Диспенсер отсутствует */
  DispenserConnectionErrorStatusType["DISPENSER_NO_DISPENSER"] = "dispenser.nodispenser"
})(DispenserConnectionErrorStatusType || (DispenserConnectionErrorStatusType = {}))
export var DispenserCriticalErrorStatusType;
(function (DispenserCriticalErrorStatusType) {
  /** Произошло наложение карты */
  DispenserCriticalErrorStatusType["DISPENSER_CARD_OVERLAPPED"] = "dispenser.card.overlapped"
  /** Произошло замятие карты */
  DispenserCriticalErrorStatusType["DISPENSER_CARD_JAM"] = "dispenser.card.jam"
})(DispenserCriticalErrorStatusType || (DispenserCriticalErrorStatusType = {}))
export var DispenserSensorStatusType;
(function (DispenserSensorStatusType) {
  DispenserSensorStatusType["DISPENSER_SENSOR_INVALID"] = "dispenser.sensor.invalid"
  DispenserSensorStatusType["DISPENSER_DISPSENSOR"] = "dispenser.dispsensor"
  DispenserSensorStatusType["DISPENSER_CAPTSENSOR1"] = "dispenser.captsensor1"
  DispenserSensorStatusType["DISPENSER_CAPTSENSOR2"] = "dispenser.captsensor2"
})(DispenserSensorStatusType || (DispenserSensorStatusType = {}))
/**
 * Сервис для работы с диспенсером
 * @version 0.0.1
 * @since 2.0.0
 */
export default class DispenserService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiDispenserMessageType.DISPENSER_FULL_STATUS:
          this.broadcast(DispenserMessageType.DISPENSER_FULL_STATUS, message)
          break
      }
    }
    this.messageChannel.subscribe(ApiDispenserMessageType.DISPENSER_FULL_STATUS, messageHandler)
  }
  /**
     * Изменился статус диспенсера
     * @since 2.0.0
     *
     * @param {(status: DispenserStatus) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DispenserService
     *
     * @example <caption>Изменился статус диспенсера</caption>
     * robot.dispenserService.onStatusChange((status) => {
     *   ...
     * })
     */
  onStatus(callback) {
    return this.subscribe(DispenserMessageType.DISPENSER_FULL_STATUS, callback)
  }
  /**
     * Сбросить карту в корзину
     * @since 2.0.0
     *
     * @return {*}  {void}
     * @memberof DispenserService
     *
     * @example <caption>Сбросить карту в корзину</caption>
     * robot.dispenserService.capture()
     */
  capture() {
    return this.messageChannel.send({
      type: ApiDispenserMessageType.DISPENSER_DISPENSE,
      capture: '',
    })
  }
  /**
     * Выдать карту в заданную позицию
     * @since 2.0.0
     *
     * @param {(string | number)} [position='full'] - позиция
     * основные позиции:
     * 'full' - выдвинуть карту наружу, но удерживать от падения
     * 'scan' - выдвинуть карту в позицию под rfid-ридером диспенсера
     * возможны также цифровые варианты 0-7 для тонких подстроек позиции
     * @memberof DispenserService
     *
     * @example <caption>Выдать карту в заданную позицию</caption>
     * robot.dispenserService.dispense('scan')
     * OR
     * robot.dispenserService.dispense(7)
     */
  dispense(position = 'full') {
    if (typeof position === 'string') {
      return this.messageChannel.send({
        type: ApiDispenserMessageType.DISPENSER_DISPENSE,
        dispense: position,
      })
    }
    else {
      return this.messageChannel.send({
        type: ApiDispenserMessageType.DISPENSER_DISPENSE,
        dispense_position: position,
      })
    }
  }
  /**
     * Перезагрузить диспенсер
     * @since 2.0.0
     *
     * @return {*}  {void}
     * @memberof DispenserService
     *
     * @example <caption>Перезагрузить диспенсер</caption>
     * robot.dispenserService.reset()
     */
  reset() {
    return this.messageChannel.send({
      type: ApiDispenserMessageType.DISPENSER_DISPENSE,
      reset: '',
    })
  }
}
